/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _extends = _interopDefault(require('babel-runtime/helpers/extends'));
var olExt = require('../ol-ext');
var assert = require('../util/assert');
var minilo = require('../util/minilo');

var _cleanExtParams = function _cleanExtParams(params) {
  return minilo.reduce(params, function (params, value, key) {
    var filterKeys = ['LAYERS', 'VERSION', 'STYLES', 'FORMAT', 'TRANSPARENT', 'BGCOLOR', 'TIME'];

    key = key.toUpperCase();
    if (filterKeys.includes(key)) {
      return params;
    }

    params[key] = value;

    return params;
  }, {});
};

var props = {
  /**
   * Extra WMS request parameters
   */
  extParams: Object,
  layers: {
    type: String,
    required: true
  },
  styles: String, // WMS Request styles
  version: {
    type: String,
    default: olExt.WMS_VERSION
  },
  transparent: {
    type: Boolean,
    default: true
  },
  format: {
    type: String,
    default: 'image/png'
  },
  bgColor: String,
  time: String
};

var computed = {
  cleanExtParams: function cleanExtParams() {
    return this.extParams ? _cleanExtParams(this.extParams) : undefined;
  },
  allParams: function allParams() {
    return _extends({}, this.cleanExtParams, {
      LAYERS: this.layers,
      STYLES: this.styles,
      VERSION: this.version,
      FORMAT: this.format,
      TRANSPARENT: this.transparent,
      BGCOLOR: this.bgColor,
      TIME: this.time
    });
  }
};

var methods = {
  /**
   * @param {number[]} coordinate
   * @param {number} [resolution]
   * @param {string} [projection]
   * @param {Object} [params] GetFeatureInfo params. `info_format` at least should be provided.
   *                          If `query_layers` is not provided then the layers specified in the `layers` prop will be used.
   *                          `version` should not be specified here (value from `version` prop will be used).
   * @return {string|undefined}
   */
  getFeatureInfoUrl: function getFeatureInfoUrl(coordinate, resolution, projection) {
    var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    assert.hasView(this);
    assert.hasSource(this);

    resolution || (resolution = this.$view.getResolution());
    projection || (projection = this.projection);
    params = _extends({}, this.allParams, params);

    return this.$source.getGetFeatureInfoUrl(coordinate, resolution, projection, params);
  }
};

var watch = {
  layers: function layers(LAYERS) {
    this.$source && this.$source.updateParams({ LAYERS: LAYERS });
  },
  version: function version(VERSION) {
    this.$source && this.$source.updateParams({ VERSION: VERSION });
  },
  styles: function styles(STYLES) {
    this.$source && this.$source.updateParams({ STYLES: STYLES });
  },
  transparent: function transparent(TRANSPARENT) {
    this.$source && this.$source.updateParams({ TRANSPARENT: TRANSPARENT });
  },
  time: function time(TIME) {
    this.$source && this.$source.updateParams({ TIME: TIME });
  },
  bgColor: function bgColor(BGCOLOR) {
    this.$source && this.$source.updateParams({ BGCOLOR: BGCOLOR });
  },
  extParams: function extParams(value) {
    this.$source && this.$source.updateParams(value ? _cleanExtParams(value) : undefined);
  }
};

var wmsSource = {
  props: props,
  computed: computed,
  methods: methods,
  watch: watch
};

module.exports = wmsSource;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/mixin/wms-source.js
// module id = 1472
// module chunks = 1